export default "__VITE_ASSET__32398609__"